<template>
  <main>
    <div class="py-2">
      <div class="tbody">
        <div v-if="!filters.filterFields.length" class="text-center pt-3">
          No filters found.
        </div>
        <div
          v-for="(filterField, index) in filters.filterFields || []"
          :key="index"
          class="d-flex filter_row p-2 mb-2 mt-2 justify-center align-items-center"
        >
          <div class="item-small item">
            <div v-if="index === 0">Where</div>
            <div v-else>{{ filterField.condition | capitalize }}</div>
          </div>
          <div class="item-large mx-1 item">
            <div>{{ fieldText(filterField) }}</div>
          </div>
          <div class="item-mid item-mid-limit d-flex mx-1 item">
            {{ typeText(filterField) }}
          </div>
          <div class="item-mid d-flex mx-1 item">
            {{ filterField.value }}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from '@vue/composition-api'
import useSectionTemplate from '@sm/client/composables/useSectionTemplate'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        filters: {
          filterFields: [],
        },
      }),
    },
  },
  setup () {
    const { sectionTemplate } = useSectionTemplate()

    const sectionTemplateQuestions = computed(() =>
      sectionTemplate.value.flattenQuestionsObjWithId2to1()
    )

    return {
      sectionTemplateQuestions,
    }
  },
  computed: {
    ...mapGetters([ 'courseFieldOptions', 'filters' ]),
    filters () {
      return this.value.filters || { filterFields: [] }
    },
    filterSpecificFields () {
      return {
        startTime: {
          name: 'startTime',
          label: 'Start Time',
          inputType: 'time',
        },
        endTime: {
          name: 'endTime',
          label: 'End Time',
          inputType: 'time',
        },
        days: {
          name: 'days',
          label: 'Days',
          inputType: 'days',
        },
      }
    },
    sectionFields () {
      return {
        ...this.sectionTemplateQuestions,
        ...this.filterSpecificFields,
      }
    },
    courseFields () {
      return Object.assign(...this.courseFieldOptions.map(el => ({ [el.name]: el })))
    },
  },
  methods: {
    typeText ({ type }) {
      if (type === 'notContains') return 'Does not contain'
      else return this.decamelize(type)
    },
    fieldText ({ group, name }) {
      if (group === 'course') {
        return (this.courseFields[name] || {}).label
      }
      if (group === 'section') {
        return (this.sectionFields[name] || {}).label
      }
    },
  },
}
</script>
<style scoped>
.item {
  min-width: 140px;
}
.item-small {
  min-width: 90px;
  width: 90px;
}
.item-mid {
  min-width: 150px;
}
.item-mid-limit {
  width: 150px;
}

.item-large {
  min-width: 250px;
  width: 250px;
}

.filter_row {
  border-radius: 5px;
  background: #f7f7f7;
}

@media screen and (max-width: 1000px) {
  .filter_row .item {
    margin: 0px !important;
    margin-bottom: 6px !important;
  }
  .filter_row {
    display: block !important;
  }
  .filter_editor {
    width: auto;
    min-width: 320px;
  }
  .item,
  .item-small,
  .item-mid,
  .item-large {
    width: 100%;
  }
}

.hoverable {
  transition: all 0.3s ease;
  cursor: pointer;
}
.hoverable:hover {
  color: inherit !important;
}
</style>
